import { render, staticRenderFns } from "./WidgetActivity.vue?vue&type=template&id=59387d26&scoped=true"
import script from "./WidgetActivity.vue?vue&type=script&lang=js"
export * from "./WidgetActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59387d26",
  null
  
)

export default component.exports